// extracted by mini-css-extract-plugin
module.exports = {"toggle-button":"_99551c8aa8--toggle-button--jtDDE"};